import { v4 as uuidv4 } from 'uuid';
import { icon, images } from '../constants';
const skillsArray = [
	{
		id: uuidv4(),
		name: 'HTML 5',
		icon: images.html,
	},
	{
		id: uuidv4(),
		name: 'CSS',
		icon: images.css,
	},
	{
		id: uuidv4(),
		name: 'Tailwind CSS',
		icon: icon.tailwindcss,
	},
	{
		id: uuidv4(),
		name: 'JavaScript',
		icon: images.javascript,
	},
	{
		id: uuidv4(),
		name: 'TypeScript',
		icon: images.typescript,
	},
	{
		id: uuidv4(),
		name: 'React JS',
		icon: images.react,
	},
	{
		id: uuidv4(),
		name: 'Styled Components',
		icon: icon.styledcomponents,
	},
	{
		id: uuidv4(),
		name: 'Next JS',
		icon: icon.nextjs,
	},
	{
		id: uuidv4(),
		name: 'MongoDB',
		icon: icon.mongodb,
	},
	{
		id: uuidv4(),
		name: 'Git',
		icon: icon.git,
	},
	{
		id: uuidv4(),
		name: 'GitHub',
		icon: icon.github,
	},

	{
		id: uuidv4(),
		name: 'Framer Motion',
		icon: icon.framermotion,
	},
	{
		id: uuidv4(),
		name: 'Figma',
		icon: images.figma,
	},
	{
		id: uuidv4(),
		name: 'Post Man',
		icon: icon.postman,
	},
	{
		id: uuidv4(),
		name: 'RESTful API',
		icon: images.api,
	},
	{
		id: uuidv4(),
		name: 'Jira',
		icon: icon.jira,
	},
	{
		id: uuidv4(),
		name: 'BitBucket',
		icon: icon.bitbucket,
	},

	{
		id: uuidv4(),
		name: 'Visual Studio Code',
		icon: icon.vscode,
	},
	{
		id: uuidv4(),
		name: 'NPM',
		icon: icon.npm,
	},
	{
		id: uuidv4(),
		name: 'Axios',
		icon: icon.axios,
	},
	{
		id: uuidv4(),
		name: 'TanStack Query',
		icon: icon.reactquery,
	},
	{
		id: uuidv4(),
		name: 'ZuStand',
		icon: images.zustand,
	},
	{
		id: uuidv4(),
		name: 'React Hook Form',
		icon: images.rhf,
	},
];
export default skillsArray;
